import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, CalendarDays } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { EVENT_CATEGORIES } from '../lib/eventData';

export default function PublicEventCard({ event }) {
  const { language } = useLanguage();
  const tr = (lv, en, ru) => (language === 'lv' ? lv : language === 'ru' ? ru : en);
  const cat = EVENT_CATEGORIES[event.category];

  const dateStr = event.event_date
    ? new Date(event.event_date).toLocaleDateString(language === 'lv' ? 'lv-LV' : language === 'ru' ? 'ru-RU' : 'en-US',
      { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <Link to={`/events/${event.id}`} className="group block bg-white border border-[#E5E4E0] rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-200" data-testid={`public-event-card-${event.id}`}>
      {event.image_url ? (
        <div className="h-40 overflow-hidden">
          <img src={event.image_url} alt={event.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        </div>
      ) : (
        <div className="h-40 bg-gradient-to-br from-[#4A6B53]/15 to-[#D97736]/15 flex items-center justify-center">
          <CalendarDays className="w-10 h-10 text-[#4A6B53]/50" />
        </div>
      )}
      <div className="p-5">
        <div className="flex items-center justify-between gap-2 mb-2">
          {cat && <Badge className="bg-[#F3F2EE] text-[#5C5C5C] border-0 font-figtree">{cat[language] || cat.lv}</Badge>}
          {event.is_paid ? (
            <span className="text-sm font-bold text-[#E11D48]">€{event.price ?? ''}</span>
          ) : (
            <span className="text-sm font-bold text-[#16A34A]">{tr('Bezmaksas', 'Free', 'Бесплатно')}</span>
          )}
        </div>
        <h3 className="font-outfit font-semibold text-[#121212] text-lg mb-2 line-clamp-1 group-hover:text-[#D97736] transition-colors">{event.title}</h3>
        {event.description && <p className="text-[#5C5C5C] text-sm line-clamp-2 mb-4 font-figtree">{event.description}</p>}
        <div className="flex items-center justify-between text-xs text-[#5C5C5C] border-t border-[#F3F2EE] pt-3">
          <span className="flex items-center gap-1 min-w-0"><MapPin className="w-3.5 h-3.5 shrink-0" /><span className="truncate">{event.location_name || event.city || event.region}</span></span>
          {dateStr && <span className="flex items-center gap-1 shrink-0"><CalendarDays className="w-3.5 h-3.5" />{dateStr}</span>}
        </div>
      </div>
    </Link>
  );
}
